import React from 'react';
import { ReactQueryProvider } from '@/utils/ReactQuery';
import { useModalManager } from '@/components/common/Modal';
import AddGlossaryTerm from './AddGlossaryTerm';

interface AddGlossaryTermButtonProps {
  buttonClassName: string;
  buttonText: string;
}

const AddGlossaryTermButton = ({ buttonClassName, buttonText }: AddGlossaryTermButtonProps) => {
  const modalManager = useModalManager();

  return (
    <ReactQueryProvider>
      <button
        className={buttonClassName}
        type="button"
        onClick={modalManager.open}
      >
        {buttonText}
      </button>
      <AddGlossaryTerm
        handleClose={modalManager.close}
        isOpen={modalManager.isOpen}
      />
    </ReactQueryProvider>
  );
};

export default AddGlossaryTermButton;
